import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./index.css";
import { API_URL } from "./App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LineChart from "./LineChart";
import BarChart from "./BarChart";
import Slider from 'react-slick';
import CardDistributionChart from "./CardDistributionChart";

function Lobby() {
  const [gameId, setGameId] = useState("");
  const [playerId, setPlayerId] = useState("");
  const [kreuzMode, setKreuzMode] = useState(true);
  const [spielVorschlag, setSpielVorschlag] = useState(true);
  const [shuffleCount, setShuffleState] = useState(15);
  const [joinedGameId, setJoinedGameId] = useState("");
  const [availableGames, setAvailableGames] = useState([]);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const ws = useRef(null); // Use `useRef` to persist the WebSocket instance across renders

  useEffect(() => {
    ws.current = new WebSocket(`${API_URL.replace("http", "ws")}/ws/lobby`);

    ws.current.onopen = () => console.log("ws opened");
    ws.current.onclose = () => console.log("ws closed");

    const wsCurrent = ws.current;
  }, []);

  useEffect(() => {
    ws.current.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        switch (data.type) {
          case "game_list":
            setAvailableGames(data.games || []);
            break;
          case "game_created":
            setSuccess(`Game "${data.gameId}" created successfully!`);
            setError("");
            break;
          case "game_joined":
            setSuccess(`Successfully joined game "${data.gameId}"`);
            setJoinedGameId(data.gameId);
            setPlayerId(playerId);
            setError("");
            break;
          case "game_started":
            if (data.gameId === joinedGameId) {
              navigate(`/game/${data.gameId}/${playerId}`);
              ws.current.close(); // Close WebSocket before navigating
            }
            break;
          case "lobby_reset":
            setSuccess("Lobby cleared.");
            break;
          case "error":
            setError(data.message || "An error occurred.");
            break;
          default:
            console.warn("Unknown WebSocket message type:", data.type);
        }
      } catch (error) {
        console.error("Error parsing WebSocket message:", error);
      }
    };

    ws.current.onerror = (error) => {
      console.error("WebSocket error:", error);
      setError("WebSocket connection error.");
    };
  }, [navigate, joinedGameId, playerId]); // Dependencies for useEffect

  const sendMessage = (message) => {
    if (ws.current && ws.current.readyState === WebSocket.OPEN) {
      ws.current.send(JSON.stringify(message));
    } else {
      setError("WebSocket is not connected.");
    }
  };

  const createGame = () => {
    if (!gameId.trim()) {
      setError("Game ID cannot be empty.");
      return;
    }
    sendMessage({ type: "create_game", gameId: gameId, kreuzMode, spielVorschlag, shuffleCount });
  };

  const joinGame = (gameIdToJoin) => {
    if (!playerId.trim()) {
      setError("Player ID cannot be empty.");
      return;
    }
    sendMessage({ type: "join_game", gameId: gameIdToJoin, playerId });
  };

  const startGame = (gameIdToStart) => {
    sendMessage({ type: "start_game", gameId: gameIdToStart });
  };

  const reset = () => {
    sendMessage({ type: "reset_lobby" });
  };

  const settings = {
    dots: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  return (
    <div id="game">
      <div class="header">
        <h2>Schafkopf Lobby</h2>
      </div>

      <div class="shadow"></div>

      {error && (
        <div class="error">
          <div className="red">
            <FontAwesomeIcon icon="fa-solid fa-circle-xmark" />
            <p>{error}</p>
          </div>
        </div>
      )}
      {success && (
        <div class="success">
          <div className="green">
            <FontAwesomeIcon icon="fa-solid fa-check" />
            <p>{success}</p>
          </div>
        </div>
      )}

      <div class="players">
        <h2>Create a Game</h2>
        <input
          placeholder="Game ID"
          value={gameId}
          onChange={(e) => setGameId(e.target.value)}
        />
        <div>
        <input type="checkbox"
               defaultChecked={true}
               onChange={e => setKreuzMode(e.target.value)}
        />
            Kreuz nach dem Solo
        <input type="checkbox"
               defaultChecked={true}
               onChange={e => setSpielVorschlag(e.target.value)}
        />
            Spielvorschläge
        </div>
        <div>
          <input
            placeholder="Runden bis Rotation"
            value={shuffleCount}
            type="number"
            onChange={(e) => setShuffleState(e.target.value)}
          />
        </div>

        <button onClick={createGame}>Create Game</button>
        <button
          onClick={reset}
          style={{ backgroundColor: "red", color: "white" }}
        >
          Clear Lobby
        </button>
      </div>
      <div class="players">
        <h2>Join a Game</h2>
        <input
          placeholder="Your Player ID"
          value={playerId}
          onChange={(e) => setPlayerId(e.target.value.trim())}
        />
      </div>
      <ul>
        {availableGames.length > 0 ? (
          availableGames.map((game) => (
            <li key={game.id}>
              {joinedGameId !== game.id ? (
                <span>
                  {game.id}{" "}
                  <button onClick={() => joinGame(game.id)}>Join</button>
                </span>
              ) : (
                <span className="green">You joined Game {game.id} </span>
              )}
              {game.player_count}/4
            </li>
          ))
        ) : (
          <p>No games available</p>
        )}
      </ul>




        <div style={{ width: '100%', maxWidth: '60em'}}>
          <Slider {...settings}>
            <div className="chart-container">
              <LineChart />
            </div>
            <div className="bar-container">
              <BarChart />
            </div>
            <div className="card-distribution">
              <CardDistributionChart />
            </div>
          </Slider>
        </div>



    </div>

     );
}

export default Lobby;
